<div class="container-fluid p-0">
  <router-outlet></router-outlet>
</div>
<app-nitro-x></app-nitro-x>
<app-google-analytics-gtag></app-google-analytics-gtag>